<script lang="ts">
	import { LANGS } from '#lib/i18n/types';
	import { i18n, setLang } from '#lib/i18n/state.svelte';

	interface Props {
		compact?: boolean;
	}
	let { compact = false }: Props = $props();
</script>

<div class="lang-toggle" role="group" aria-label="Language / Dil">
	{#each LANGS as l (l.code)}
		<button
			type="button"
			class="lang-btn"
			class:active={i18n.lang === l.code}
			onclick={() => setLang(l.code)}
			aria-pressed={i18n.lang === l.code}
			title={l.label}
		>
			{l.short}
		</button>
	{/each}
</div>

<style>
	.lang-toggle {
		display: inline-flex;
		border: 1px solid var(--line-strong);
		border-radius: 8px;
		overflow: hidden;
		background: #fff;
		box-shadow: var(--shadow-sm);
	}
	.lang-btn {
		border: 0;
		background: transparent;
		padding: 0.28rem 0.5rem;
		min-height: 34px;
		min-width: 34px;
		font-size: 0.72rem;
		font-weight: 700;
		letter-spacing: 0.03em;
		color: var(--muted);
		cursor: pointer;
	}
	.lang-btn + .lang-btn {
		border-left: 1px solid var(--line);
	}
	.lang-btn.active {
		background: var(--ink);
		color: var(--paper);
	}
	.lang-btn:hover:not(.active) {
		background: var(--paper-2);
		color: var(--ink);
	}

	@media (max-width: 900px) {
		.lang-btn {
			min-height: 44px;
			min-width: 44px;
		}
	}
</style>
